const routes = [
  {
    index: true,
    label: 'Marius Scarlat',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Recruiters',
    path: '/recruiters',
  },
  {
    label: 'Blog',
    path: '/blog',
    badge: 'coming soon',
  },
];

export default routes;
